<template>
  <v-dialog-select
    ref="dialog"
    v-model="val"
    label="费用代码"
    :headers="headers"
    item-text="subjectName"
    item-value="id"
    :req-url="reqUrl"
    :search-remain="searchObj"
    @select="
      (item) => {
        $emit('select', item)
      }
    "
    max-width="1300"
    :disabled="disabled"
    :readonly="readonly"
    :init-selected="initSelected"
    :rules="rules"
    :clearable="clearable"
    @clear="clearSup"
    fuzzy-label="模糊搜索"
  >
    <!-- <template v-slot:[`item.name`]="{ item }">
      {{ item.supplierOutputDTO.name }}
    </template>
    <template v-slot:[`item.nameEn`]="{ item }">
      {{ item.supplierOutputDTO.nameEn }}
    </template>
    <template v-slot:[`item.sapCode`]="{ item }">
      {{ item.supplierOutputDTO.sapCode }}
    </template>
    <template v-slot:[`item.account`]="{ item }">
      {{ item.supplierOutputDTO.account }}
    </template> -->
  </v-dialog-select>
</template>
<script>
export default {
  name: 'v-cost-subject-communication-fee-select',
  model: {
    prop: 'value',
    event: 'update',
  },
  inject: {
    form: { default: null },
  },
  created() {
    this.form && this.form.register(this)
    // if (this.value) {
    //   this.val = this.initText
    // }
    this.reqUrl = '/business/shipAffairs/costSubject/page'
    this.headers = [
      { text: '科目名称', value: 'subjectName' },
      { text: '科目业务分类', value: 'subjectType' },
      { text: 'SAP代码', value: 'sapCode' },
    ]
    this.equipmentStatuses = [
      { text: '使用', value: 1 },
      { text: '停用', value: 2 },
      { text: '报废', value: 3 },
    ]
    this.euipmentTypes = [
      { text: '主机', value: '0' },
      { text: '副机', value: '1' },
      { text: '辅助设备', value: '2' },
      { text: '通导设备', value: '3' },
      { text: '主机附属设备', value: '4' },
      { text: '副机附属设备', value: '5' },
    ]
    this.filterFunc = (items) =>
      items.map((item) => ({
        ...item.supplierPurchaserOutputDTO,
        ...item.supplierOutputDTO,
        currency: item.supplierBankListOutputDTO,
      }))
    this.form && this.form.register(this)
  },
  props: {
    // 仅可清空，不得对该值进行其它变动
    value: [String, Object],
    // 初始化时，如果有默认值，仅触发一次，value值自行控制
    initSelected: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: [Boolean, String],
      default: false,
    },
    readonly: {
      type: [Boolean, String],
      default: false,
    },
    rules: Array,
    shipCode: {
      type: String,
      default: '',
    },
    currency: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      searchObj: { subjectType: '通讯费' },
      loading: false,
      supItems: [],
      text: '',
      supplierName: '',
      selected: false,
      dialog: false,
      val: '',
    }
  },

  computed: {
    supHeaders() {
      return [
        {
          text: '供应商名称',
          value: 'name',
          filter: (value) => {
            if (!value) return true
            return value.toLowerCase().includes(this.supplierName.toLowerCase())
          },
        },
        { text: '英文名称', value: 'nameEn' },
        { text: '账号', value: 'account' },
        { text: 'sap代码', value: 'sapCode' },
        { text: '评级打分', value: 'score' },
      ]
    },
  },

  watch: {
    value(val) {
      this.val = val
    },
    val(val) {
      this.$emit('update', val)
    },
    initSelected(val) {
      if (val) {
        this.selected = this.initSelected
        this.text = this.initSelected.name
      }
    },
    shipCode(val) {
      // if (val) this.loadSups(this.supplierName)
      this.searchObj.shipCode = val
    },
  },

  methods: {
    async loadSups(supplierName) {
      this.loading = true
      const { data } = await this.getAsync(
        '/business/shipAffairs/Supplier/getSupplierMessageByShipCodeAndType',
        { shipCode: this.shipCode, supplierName },
      )
      this.supItems = data.map((item) => ({
        ...item.supplierOutputDTO,
        currency: item.supplierBankListOutputDTO,
      }))
      if (this.selected)
        this.$emit(
          'update:currency',
          this.supItems.find((item) => item.id === this.selected.id).currency,
        )
      this.loading = false
    },

    confirm() {
      this.text = this.selected.name
      this.$emit('update', this.selected.id)
      // this.$emit('update:currency', this.selected.currency)
      this.dialog = false
    },

    validate(force, value) {
      return this.$refs.dialog.validate(force, value)
    },
    reset() {
      this.$refs.dialog.reset()
    },
    resetValidation() {
      this.$refs.dialog.resetValidation()
    },

    clearSup() {
      this.$emit('update', '')
    },
  },

  async mounted() {
    // if (this.initSelected) {
    //   this.selected = this.initSelected
    //   this.$emit('update', this.selected.id)
    //   this.$emit('update:currency', this.selected.currency)
    // }
    this.searchObj.shipCode = this.shipCode
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
}
</script>

<style scoped>
.v-dialog__content {
  position: absolute !important;
}
</style>
